import React, { useCallback, useEffect, useState } from 'react';
import { breakpoints } from '@naf/theme';
import { AdvancedImage, responsive, lazyload, placeholder } from '@cloudinary/react';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import { useWindowResize } from '@hooks/Window/useWindowResize';
import { CloudinaryVideoType, CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import { ImageBox, StyledVideo } from './styles';

export const HeroPictureImage = ({ image, video }: { image: CloudinaryImageType; video: CloudinaryVideoType }) => {
  const publicId = image?.public_id || image?.publicId || video?.publicId;
  const { getResponsiveImage, getResponsiveVideo } = useCloudinary();

  const [mainImage, setMainImage] = useState(
    getResponsiveImage(publicId, { width: 539, height: 464, focusMethod: image?.focus }),
  );

  const cldVideo = video && getResponsiveVideo(publicId);

  const setResponsiveImage = useCallback(() => {
    if (publicId && typeof window !== 'undefined') {
      const width = window.innerWidth <= parseInt(breakpoints.m, 10) ? Math.round(window.innerWidth) : 539;
      const height = window.innerWidth <= parseInt(breakpoints.m, 10) ? Math.round(width * 0.86) : 464;
      setMainImage(
        getResponsiveImage(publicId, {
          width,
          height,
          focusMethod: image?.focus,
        }),
      );
    }
  }, [getResponsiveImage, image?.focus, publicId]);

  useEffect(() => {
    setResponsiveImage();
  }, [setResponsiveImage]);

  useWindowResize(() => {
    setResponsiveImage();
  });

  return (
    <ImageBox>
      {video && cldVideo ? (
        <StyledVideo
          cldVid={cldVideo}
          plugins={[responsive({ steps: 50 }), placeholder({ mode: 'blur' })]}
          controls={false}
          autoPlay
          muted
          playsInline
          loop
        />
      ) : (
        mainImage && (
          <AdvancedImage
            cldImg={mainImage}
            plugins={[lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 }), placeholder({ mode: 'blur' })]}
            alt={image.alt || image.altText || image.caption}
          />
        )
      )}
    </ImageBox>
  );
};
